export const aboutData = {
  paragraphs: [
    "I'm a junior web developer who brings a unique perspective from my combination of technical skills and business management experience. After successfully managing teams in hospitality, I decided it was time for a change, and took a leap of faith by going back to school to study IT Web Programming (a field I had zero previous experience in - but found fascinating).",
    
    "I graduated from NSCC's IT Web Programming program in 2024 and immediately landed a 6-month contract position at Smartfirm, where I worked on cutting-edge AI integration projects. This experience allowed me to combine traditional web development with innovative AI solutions, creating custom GPTs and developing frontend interfaces for next-generation learning tools.",
    
    "My management background gives me a deep understanding of user experience and team dynamics, while my technical skills enable me to build solutions that truly serve both users and business objectives. I love working in collaborative environments and enjoy figuring out challenges that require both my creative and technical side."
  ],
  
  skillTags: [
    "GPT Creation",
    "Prompt Engineering", 
    "Leadership Skills",
    "Career Change",
    "Problem Solveing"
  ],
  
  infoCards: [
    {
      title: "My Unique Value",
      content: "Combining my business background with my technical skills to build solutions that work for both users and businesses."
    },
    {
      title: "My Current Tech Stack", 
      content: "React, Next.js, TypeScript, Tailwind CSS, PHP, WordPress, MySQL, custom GPT creation and prompt engineering."
    },
    {
      title: "Beyond Coding",
      content: "When I'm not developing, I'm crafting, experimenting with new recipes, diving into fantasy novels, and enjoying quality time with family."
    },
    {
      title: "Continuous Learning",
      content: "Currently I am rebuilding my portfolio website (this profile actually) using more sought after skills. I have also been completing Leetcode and Hackerrank styled challenges to keep up my skills, and have started learning more about AWS services."
    }
  ]
};